import React, { FC } from 'react';

import { EquipmentLocation } from '@app/api/models/equipment';
import { useFetchData, useApi } from '@app/hooks';
import { QueryTable } from '@app/components/common/table';

import { columns } from './columns';

const EquipmentsLocationTable: FC = () => {
  const api = useApi();
  const [fetchData] = useFetchData<EquipmentLocation>({ method: api.equipments.getEquipmentsLocations });

  return (
    <>
      <QueryTable<EquipmentLocation>
        title="Локации"
        columns={columns}
        fetchData={fetchData}
        canDownload
      />
    </>
  );
};

export default EquipmentsLocationTable;
